/** SSOT bank-transfer payment instructions (mirrors BE lds_bank_transfer_details_ssot.py). */

export const LDS_DOMESTIC_BANK_TRANSFER = {
  beneficiaryHe: 'ריבר אנ מור בע"מ',
  bankNameHe: "בנק דיסקונט — סניף 176 (המפרץ)",
  accountNumber: "067427",
  footerNoteHe: "לאחר ביצוע ההעברה יש לשלוח אישור תשלום לצוות החברה.",
};

export const LDS_INTERNATIONAL_BANK_TRANSFER = {
  bankNameEn: "ISRAEL DISCOUNT BANK LTD",
  bankNumber: "0011",
  branchNumber: "0176",
  swiftBic: "IDBLILITXXX",
  iban: "IL850111760000186314827",
  currencyEn: "ILS – NEW ISRAELI SHEKEL",
  beneficiaryEn: "RIVER N MOR LTD",
};

export const LDS_BANK_TRANSFER_PENDING_BADGE_HE = "ממתין להעברה בנקאית";

export const LDS_BANK_TRANSFER_SUCCESS_TITLE_HE =
  "ההזמנה שוריינה וממתינה לאישור תשלום בהעברה בנקאית";

export const LDS_BANK_TRANSFER_SUCCESS_SUBTITLE_HE =
  "האישור הסופי והשובר יחולו לאחר קליטת מלוא התשלום ואישור הנהלת החשבונות.";

/**
 * @param {Array<[string, string]>} rows
 */
export function formatBankTransferBlockText(rows) {
  return rows
    .map(([label, value]) => `${label}: ${String(value ?? "").trim()}`)
    .filter((line) => !line.endsWith(": "))
    .join("\n");
}

export function formatDomesticBankTransferText(
  details = LDS_DOMESTIC_BANK_TRANSFER
) {
  return formatBankTransferBlockText([
    ["מוטב", details.beneficiaryHe],
    ["בנק", details.bankNameHe],
    ["חשבון", details.accountNumber],
  ]);
}

export function formatInternationalBankTransferText(
  details = LDS_INTERNATIONAL_BANK_TRANSFER
) {
  return formatBankTransferBlockText([
    ["Bank name", details.bankNameEn],
    ["Bank number", details.bankNumber],
    ["Branch number", details.branchNumber],
    ["SWIFT / BIC", details.swiftBic],
    ["IBAN", details.iban],
    ["Currency", details.currencyEn],
    ["Beneficiary", details.beneficiaryEn],
  ]);
}

/**
 * @param {string} text
 */
export async function copyBankTransferLine(text) {
  const value = String(text || "").trim();
  if (!value || typeof navigator === "undefined" || !navigator.clipboard) {
    return false;
  }
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
